/**
 * Scene definition with map file and optional lighting overrides.
 */
export interface SceneDefinition {
  /** The map file name (without extension) */
  readonly mapFile: string;
  /**
   * Optional ambient light override (0-15).
   * If undefined, uses day/night cycle from GameTimeService.
   * 0 = complete darkness, 15 = full daylight
   */
  readonly ambientLightOverride?: number;
}

const SCENE_DEFINITIONS_INTERNAL = {
  overworld: { mapFile: 'kernow' },
  oldSuccess: { mapFile: 'old-success' },
} as const satisfies { [key: string]: SceneDefinition };

export type SceneId = keyof typeof SCENE_DEFINITIONS_INTERNAL;

export const SCENE_DEFINITIONS: Record<SceneId, SceneDefinition> = SCENE_DEFINITIONS_INTERNAL;
